// extracted by mini-css-extract-plugin
module.exports = {"header":"AccountCreatedView_header__lHujU","description":"AccountCreatedView_description__2Zx-e"};